export const useTableConfig = () => {
  const { t } = useI18n()

  const COLUMNS = [
    {
      name: t('cookies.table.providerName'),
    },
    {
      name: t('cookies.table.nameCookie'),
    },
    {
      name: t('cookies.table.expired'),
    },
    {
      name: t('cookies.table.means'),
    },
  ]

  return {
    COLUMNS,
  }
}
